export { default } from "./PostImageWithAltText";
